









































  import { Vue, Component, Prop } from 'vue-property-decorator'
  import OneProductStocksLabel from '~/components/organisms/product/OneProductStocksLabel.vue'

  @Component({
    components: { OneProductStocksLabel },
  })
  export default class OneProductStocksPopupDialog extends Vue {
    showStocksPopup: boolean = false

    closable: any = {
      exclude: ['button'],
      handler: 'onClose',
    }

    @Prop({
      type: Array,
      required: true,
    })
    warehouses!: Array<any>

    @Prop({
      type: String,
      required: true,
    })
    unit!: string

    @Prop({
      type: String,
      required: true,
    })
    moreStocksTxt!: string

    @Prop({
      required: true,
    })
    product!: any

    @Prop({
      required: true,
    })
    productBlocked!: boolean

    getIconClass(type) {
      return type === 'LOCAL' ? 'icon-geolocalize' : 'icon-main-warehouse'
    }

    checkStockQty(stock: any): string {
      if (this.productBlocked && stock.quantity === 0) {
        return ''
      } else if (!this.productBlocked && stock.quantity === 0) {
        return this.product.shippingTime
      } else {
        return this.shippingTime(stock.shippingTime)
      }
    }

    onClose() {
      this.showStocksPopup = false
    }

    shippingTime(time: string): string {
      return time ? `${time} ${this.$t('product_page.hour')}` : ''
    }
  }
